import { useEffect } from "react";

export const useToggleVLibras = () => {
  const syncState = (enabled: boolean) => {
    const wrapper = document.querySelector("div[vw]");
    const pluginWrapper = document.querySelector("[vw-plugin-wrapper]");

    if (!wrapper || !(pluginWrapper instanceof HTMLElement)) return;

    if (enabled) {
      wrapper.classList.add("enabled");
      pluginWrapper.classList.add("active");
    } else {
      wrapper.classList.remove("enabled");
      pluginWrapper.classList.remove("active");
    }

    console.log("[VLibras] synced:", enabled);
  };

  const toggleVLibras = () => {
    const wrapper = document.querySelector("div[vw]");
    const isEnabled = wrapper?.classList.contains("enabled");

    syncState(!isEnabled);
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const closeButton = document.querySelector(
        "[vw-plugin-wrapper] .vpw-header-btn-close"
      );

      if (!closeButton) return;

      const handleClose = () => {
        console.log("[VLibras][close] native close detected");

        // deixa a lib fechar normalmente
        // só sincroniza o estado visual depois
        requestAnimationFrame(() => {
          syncState(false);
        });
      };

      closeButton.addEventListener("click", handleClose);

      observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return { toggleVLibras };
};
